import * as React from "react";
import PropTypes from 'prop-types';

const SvgNewRewards = props => {
  if (props.id !== "_svgnewrewards") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M15.8 3.6C9.063 3.6 3.6 9.063 3.6 15.8 3.6 22.537 9.063 28 15.8 28 22.538 28 28 22.537 28 15.8c0-6.737-5.462-12.2-12.2-12.2zM2.4 15.8c0-7.4 6-13.4 13.4-13.4s13.4 6 13.4 13.4-6 13.4-13.4 13.4-13.4-6-13.4-13.4zm14.57-6.855h-1.563l.059 1.498c-1.64.273-2.93 1.407-2.93 3.126 0 1.485.917 2.343 2.421 3.047l1.018.45c1.249.566 1.992.977 1.992 1.876 0 .84-.586 1.483-1.992 1.483-1.348 0-2.424-.663-2.95-1.152L11.968 20.7c.489.43 1.524 1.133 3.283 1.27l-.02 1.085h1.562l-.059-1.144c2.072-.312 3.068-1.7 3.068-3.145 0-1.623-1.035-2.345-2.676-3.068l-.88-.39c-1.133-.508-1.874-.977-1.874-1.896 0-.879.663-1.426 1.835-1.426.88 0 1.72.371 2.228.84l1.094-1.387c-.371-.332-1.23-.898-2.56-1.036V8.945z" fill="#E71324" /></svg>;
};

SvgNewRewards.displayName = "_svgnewrewards";
SvgNewRewards.propTypes = {
  id: PropTypes.string
};
SvgNewRewards.defaultProps = {
  id: ''
};
export default SvgNewRewards;